import { vendorLookupLabel } from './vendor-membership-lookup.util';

/**
 * CWS-1536: which memberships offer Update Payment method, and in which form. A Way membership
 * gets the card picker. An imported one (DRB, iWash...), when its company has the super-admin
 * flag on, gets a notice that its payments go through the vendor, with no cards to add or choose:
 * those come once the member is billed by Way. Shared by the Subscriptions tab and the lane pop-ups.
 */

/** A membership imported from a vendor. No source is Way: a lane plate-scan payload carries none. */
export function isImportedMembershipSource(source: string | null | undefined): boolean {
  const key = String(source ?? '')
    .trim()
    .toLowerCase();
  return key !== '' && key !== 'way';
}

/** The vendor an imported membership's payments go through ("DRB"); null for a Way membership. */
export function importedBilledBy(source: string | null | undefined): string | null {
  return isImportedMembershipSource(source) ? vendorLookupLabel(source) : null;
}

/** The fields of a Subscriptions tab membership the imported notice depends on. */
export interface ImportedPaymentMethodSource {
  source: string | null | undefined;
  is_live: boolean;
  display_status: string;
  is_way_app?: boolean;
}

/**
 * Whether a Subscriptions tab membership offers the imported notice: a live, active import (not a
 * Way-app pass) while the company has it switched on.
 */
export function offersImportedPaymentMethod(
  subscription: ImportedPaymentMethodSource,
  importedEnabled: boolean
): boolean {
  return (
    importedEnabled &&
    subscription.is_live &&
    subscription.display_status === 'active' &&
    !subscription.is_way_app &&
    isImportedMembershipSource(subscription.source)
  );
}
